package app.nestbridge.app.usecase

import com.karawek.core.auth.util.AuthNavigationUtils
import me.tatarka.inject.annotations.Inject

@Inject
class LogoutUseCase(
    private val authNavigationUtils: AuthNavigationUtils,
) {
    suspend operator fun invoke() {
        authNavigationUtils.logout()
    }
}
